module.exports = __webpack_public_path__ + "img/12.e70f4b60.svg";